import { BrowserRouter as Router ,Routes,Route   } from "react-router-dom";
import App from "../App";

import Invite from '../views/invite/Index'
import Reg from '../views/invite/reg'
import Allocation from '../views/invite/allocation'
import Star from '../views/invite/star'
import Invite1 from '../views/invite/index1' 
import PreSale from '../views/invite/PreSale'
import AfterSale from '../views/invite/AfterSale'
import St from '../views/invite/st'
import Mint from '../views/invite/Mint'
import Mintt from '../views/invite/Mintt'
import DepUsdt from '../views/invite/DepUsdt'
import ColUsdt from '../views/invite/ColUsdt'
import Dash from '../views/invite/Dash'
import Rank from '../views/invite/Rank'
import Mining from '../views/invite/Mining'
import Air from '../views/invite/Air'
import Nft from '../views/invite/Nft'
import Box from '../views/invite/Box'
import Pledge from '../views/pledge/Index'
import Staking from '../views/pledge/Staking'
import My from '../views/my/Index'
import Usdt from '../views/my/Usdt'
import Manad from '../views/my/manad'
import AssetTest from '../views/my/IndexTest'
import AssetTest1 from '../views/my/IndexTes1'
import AssetTest2 from '../views/my/IndexTes2'
import LiuShuiHsbc from '../views/liushui/IndexHsbc'
import LiuShuiUsdt from '../views/liushui/IndexUsdt'
import LiuShuiMeba from '../views/liushui/IndexMeba'
import LiuShuiMarsx from '../views/liushui/IndexMarsx'
import LiuShuiFegwPool from '../views/liushui/IndexFegwPool'
import LiuShuiEth from '../views/liushui/IndexEth'
import MappingPro from '../views/my/Index'
import Pool from '../views/mapping/Pool'
import Game from '../views/game/game'
import Game1 from '../views/game/game1'
import Game160 from '../views/game/game160'

// import Node from '../views/node/Index'
// import Hold from '../views/invite/Buyhero'
// import Up from '../views/invite/Up'
// import Job from '../views/invite/Job'
// import Hero from '../views/invite/Hero'
// import Boss from '../views/invite/Boss'
// import Ccer from '../views/pledge/ccer'
// import LiuShuiEth1 from '../views/liushui/IndexEth1'
// import Mapping from '../views/mapping/Index'
// import Mapping1 from '../views/mapping/Index1'
// import MappingEth from '../views/mapping/IndexEth'
// import Deposit from '../views/deposit/Index'
import Swap from '../views/invite/Swap'
// import Swap1 from '../views/swap/Index1'
// import Market from '../views/market/Index'
// import Web from '../views/web/Web'
// import Tr from '../views/tr/Index'
// import TrMy from '../views/tr/TrMy'



const BaseRouter = () => {
    
    return(
        <Router>
            
            <Routes>
                <Route path="/" element={<App/>}>
                
                    {/* <Route path="/web" element={<Web/>}></Route> */}
                    <Route path="/star" element={<Star/>}></Route>
                    <Route path="/allocation" element={<Allocation/>}></Route>
                    <Route path="/reg" element={<Reg/>}></Route>
                    <Route path="/presale" element={<PreSale/>}></Route>
                    <Route path="/aftersale" element={<AfterSale/>}></Route>
                    <Route path="/air" element={<Air/>}></Route>
                    <Route path="/depUsdt" element={<DepUsdt/>}></Route>
                    <Route path="/colUsdt" element={<ColUsdt/>}></Route>
                    <Route path="/usdtusdt" element={<Usdt/>}></Route>
                    <Route path="/manad" element={<Manad/>}></Route>
                    <Route path="/game" element={<Game/>}></Route>
                    <Route path="/game1" element={<Game1/>}></Route>
                    <Route path="/game160" element={<Game160/>}></Route>
                    <Route path="/invite" element={<Invite/>}></Route>
                    <Route path="/invite1" element={<Invite1/>}></Route>
                     <Route path="/dash" element={<Dash/>}></Route>
                         <Route path="/rank" element={<Rank/>}></Route>
                         <Route path="/mining" element={<Mining/>}></Route>
                    <Route path="/mint" element={<Mintt/>}></Route>
                    {/* <Route path="/buyhero" element={<Hold/>}></Route> */}
                    {/* <Route path="/up" element={<Up/>}></Route> */}
                    {/* <Route path="/job" element={<Job/>}></Route> */}
                    {/* <Route index element={<Mint/>}></Route> */}
                    {/* <Route path="/node" element={<Node/>}></Route> */}
                    <Route path="/st" element={<St/>}></Route>
                    <Route path="/pledge1" element={<Pledge/>}></Route>
                    {/* <Route path="/tr" element={<Tr/>}></Route> */}
                    {/* <Route path="/trmy" element={<TrMy/>}></Route> */}
                    <Route path="/pledge" element={<Staking/>}></Route>
                    <Route path="/my" element={<My/>}></Route>
                    
                    <Route path="/task" element={<Nft/>}></Route>
                    <Route index element={<Box/>}></Route>
                    {/* <Route path="/hero" element={<Hero/>}></Route>
                    <Route path="/boss" element={<Boss/>}></Route> */}
                    {/* <Route path="/web" element={<Web/>}></Route> */}
                    <Route path="/record_hsbc" element={<LiuShuiHsbc/>}></Route>
                    <Route path="/record_usdt" element={<LiuShuiUsdt/>}></Route>
                    <Route path="/record_bcbse" element={<LiuShuiMeba/>}></Route>
                    <Route path="/record_usdtb" element={<LiuShuiMarsx/>}></Route>
                    <Route path="/record_fegw_pool" element={<LiuShuiFegwPool/>}></Route>
                    <Route path="/record_bnb" element={<LiuShuiEth/>}></Route>
                    {/* <Route path="/record_eth1" element={<LiuShuiEth1/>}></Route> */}
                    {/* <Route path="/mapping" element={<Mapping/>}></Route> */}
                    <Route path="/asset" element={<AssetTest2/>}></Route>
                    <Route path="/assetlist" element={<AssetTest2/>}></Route>
                      <Route path="/assettest" element={<AssetTest/>}></Route>
                      <Route path="/assettest1" element={<AssetTest1/>}></Route>
                    <Route path="/pool" element={<Pool/>}></Route>
                    {/* <Route path="/mapping1" element={<Mapping1/>}></Route>
                    <Route path="/mappingEth" element={<MappingEth/>}></Route> */}
                    {/* <Route path="/deposit" element={<Deposit/>}></Route> */}
                    <Route path="/swap" element={<Swap/>}></Route>
                    {/* <Route path="/swap1" element={<Swap1/>}></Route> */}
                    {/* <Route path="/market" element={<Market/>}></Route>
                    <Route path="/ccer" element={<Ccer/>}></Route> */}
                </Route>
          
                <Route path="*" element={<App/>}></Route>
            </Routes>
           

        </Router>
        
    )
}

export default BaseRouter;